import { COLLECTIONS } from "constants/action-types";

export interface IAddItem {
    itemsId: string;
    addType?: string;
    attributes?: any;
    index?: number;
    productId?: string;
    rowId?: string;
    skipScroll?: boolean;
    collectionId?: string;
    selected?: boolean;
}

export const addItem = (payload: IAddItem, meta: { history?: boolean } = {}) => ({
    payload,
    meta,
    type: COLLECTIONS.COLLECTION.ITEMS.ITEM.CREATE,
});

export const removeItem = (itemsId: string, index: number) => ({
    payload: { itemsId, index },
    type: COLLECTIONS.COLLECTION.ITEMS.ITEM.REMOVE,
});

export const removeItems = (itemsId: string, bulkItems: any, options = {}) => ({
    payload: { itemsId, bulkItems, options },
    type: COLLECTIONS.COLLECTION.ITEMS.REMOVE,
});

export const moveItem = (itemsId: string, index: number, destinationIndex: number, rowId: string) => ({
    payload: { itemsId, index, destinationIndex, rowId },
    type: COLLECTIONS.COLLECTION.ITEMS.ITEM.MOVE,
});

export interface IMutateCollectionItemPayload {
    itemsId: string;
    index: number;
    item: any;
    value?: string;
    meta?: {};
    fieldName?: string;
}
export interface IMutateCollectionItemAction {
    payload: IMutateCollectionItemPayload;
    type: string;
}

export const mutateCollectionItem = (payload: IMutateCollectionItemPayload) => ({
    payload,
    type: COLLECTIONS.COLLECTION.ITEMS.ITEM.MUTATE,
});

export const setScrollTo = (index) => ({
    payload: { index },
    type: COLLECTIONS.COLLECTION.ITEMS.SCROLL_TO,
});

export const addBulkItems = (
    catalogId: string,
    itemsId: string,
    lastIndex: string,
    collectionId: string,
    filterInAssortment?: string
) => ({
    payload: { catalogId, itemsId, lastIndex, collectionId, filterInAssortment },
    type: COLLECTIONS.COLLECTION.ITEMS.BULK.START,
});

export const missedBulkItemsViewed = () => ({ type: COLLECTIONS.COLLECTION.ITEMS.BULK.MISSING_PRODUCTS.VIEWED });
